(function () {
  "use strict";
  var $ = function (s, c) {
      return (c || document).querySelector(s);
    },
    $$ = function (s, c) {
      return Array.prototype.slice.call((c || document).querySelectorAll(s));
    },
    reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches,
    DATA = window.OSZEA_KIDS || {
      title: "Kids Melbourne Chelsea",
      priceCents: 11e3,
      currency: "NZD",
      cartAddUrl: "/cart/add.js",
      cartUrl: "/cart",
      colours: [
        {
          id: "thunder-pop",
          name: "Thunder Pop",
          sub: "Black + white. Built for big energy.",
          sticker: "Big energy mode",
          accent: "#3BB0AA",
          sw: ["#23282d", "#ffffff"],
          tag: "Sporty",
          images: [],
        },
        {
          id: "rain-ranger",
          name: "Rain Ranger",
          sub: "All black. Ready for school missions.",
          sticker: "School morning approved",
          accent: "#3a4047",
          sw: ["#23282d", "#23282d"],
          tag: "Bold",
          images: [],
        },
        {
          id: "puddle-pop",
          name: "Puddle Pop",
          sub: "Pink + white. Made for puddle queens.",
          sticker: "Puddle-ready",
          accent: "#EE7FA6",
          sw: ["#EE7FA6", "#ffffff"],
          tag: "Playful",
          images: [],
        },
      ],
      sizes: [
        { s: "13", age: "4\u20135 yr" },
        { s: "1", age: "5\u20136 yr" },
        { s: "2", age: "6\u20137 yr" },
        { s: "3", age: "7\u20138 yr" },
        { s: "4", age: "8\u20139 yr" },
      ],
      variants: {},
    },
    VIEWS = [
      "On-Foot",
      "In the Rain",
      "Side Profile",
      "Slip-On Pull Tab",
      "Flexible Sole",
      "Colour-In Shoebox",
    ],
    PRICE_CENTS = DATA.priceCents || 11e3,
    COLOURS = DATA.colours || [],
    SIZES = DATA.sizes || [],
    VARIANTS = DATA.variants || {},
    state = {
      colour: (COLOURS[0] && COLOURS[0].id) || "puddle-pop",
      size: null,
      qty: 1,
      slide: 0,
    };
  (function () {
    for (var i = 0; i < COLOURS.length; i++)
      if (colourHasStock(COLOURS[i].id)) {
        state.colour = COLOURS[i].id;
        return;
      }
  })();
  function colourObj(id) {
    id = id || state.colour;
    for (var i = 0; i < COLOURS.length; i++)
      if (COLOURS[i].id === id) return COLOURS[i];
    return COLOURS[0];
  }
  function variantFor(colourId, size) {
    return VARIANTS[(colourId || state.colour) + "|" + size];
  }
  function isSold(sz) {
    var v = variantFor(state.colour, sz);
    return !!v && v.available === !1;
  }
  function selectedSold() {
    return isSold(state.size);
  }
  function isLow(sz) {
    var v = variantFor(state.colour, sz);
    return (
      !!v &&
      v.available !== !1 &&
      typeof v.qty == "number" &&
      v.qty > 0 &&
      v.qty <= 4
    );
  }
  function colourHasStock(id) {
    for (var i = 0; i < SIZES.length; i++) {
      var v = variantFor(id, SIZES[i].s);
      if (v && v.available !== !1) return !0;
    }
    return !1;
  }
  var SYMBOLS = {
    INR: "\u20B9",
    USD: "$",
    NZD: "$",
    AUD: "$",
    CAD: "$",
    EUR: "\u20AC",
    GBP: "\xA3",
    JPY: "\xA5",
    VND: "\u20AB",
    SGD: "$",
    HKD: "$",
    MYR: "RM",
    PHP: "\u20B1",
    THB: "\u0E3F",
    KRW: "\u20A9",
    CNY: "\xA5",
    TWD: "NT$",
    AED: "AED ",
    ZAR: "R",
    CHF: "CHF ",
  };
  function money(cents) {
    var curr = (
        (window.OSZEA_PDP && window.OSZEA_PDP.currency) ||
        (window.Shopify &&
          window.Shopify.currency &&
          window.Shopify.currency.active) ||
        (DATA && DATA.currency) ||
        "NZD"
      ).toUpperCase(),
      sym = SYMBOLS[curr] || "$",
      dollars = Number(cents) / 100,
      noDecimals = ["JPY", "KRW", "VND"].indexOf(curr) !== -1,
      formatted;
    return (
      noDecimals
        ? (formatted = Math.round(dollars).toLocaleString("en-US"))
        : curr === "INR"
          ? (formatted =
              dollars % 1 === 0
                ? dollars.toLocaleString("en-IN")
                : dollars.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }))
          : (formatted =
              dollars % 1 === 0
                ? dollars.toLocaleString("en-US")
                : dollars.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })),
      sym + formatted + " " + curr
    );
  }
  function toast(msg) {
    var zone = $("#toastZone");
    if (zone) {
      var t = document.createElement("div");
      ((t.className = "toast"),
        (t.innerHTML =
          '<span class="tk"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="m5 13 4 4L19 7"/></svg></span>' +
          msg),
        (t.style.cursor = "pointer"),
        t.setAttribute("role", "link"),
        t.setAttribute("tabindex", "0"),
        t.addEventListener("click", function () {
          window.location.href = "/cart";
        }),
        t.addEventListener("keydown", function (e) {
          (e.key === "Enter" || e.key === " ") &&
            (e.preventDefault(), (window.location.href = "/cart"));
        }),
        zone.appendChild(t),
        requestAnimationFrame(function () {
          t.classList.add("show");
        }),
        setTimeout(function () {
          (t.classList.remove("show"),
            setTimeout(function () {
              t.remove();
            }, 400));
        }, 2600));
    }
  }
  var stage = $("#kcStage"),
    track = $("#kcTrack"),
    thumbsWrap = $("#kcThumbs"),
    dotsWrap = $("#kcDots"),
    counter = $("#kcCounter"),
    stagePrev = $("#kcStagePrev"),
    stageNext = $("#kcStageNext"),
    thumbPrev = $("#kcThumbPrev"),
    thumbNext = $("#kcThumbNext");
  (stagePrev &&
    stagePrev.addEventListener("click", function () {
      var n = state.slide - 1;
      (n < 0 && (n = (slideCount() || VIEWS.length) - 1), goSlide(n));
    }),
    stageNext &&
      stageNext.addEventListener("click", function () {
        var n = state.slide + 1;
        (n >= (slideCount() || VIEWS.length) && (n = 0), goSlide(n));
      }),
    thumbPrev &&
      thumbPrev.addEventListener("click", function () {
        thumbsWrap.scrollBy({ top: -150, behavior: "smooth" });
      }),
    thumbNext &&
      thumbNext.addEventListener("click", function () {
        thumbsWrap.scrollBy({ top: 150, behavior: "smooth" });
      }));
  function slidesForColour() {
    var c = colourObj();
    return c.images && c.images.length
      ? c.images.map(function (src, i) {
          return {
            img: src,
            label: c.name + " \u2014 " + (VIEWS[i] || "View " + (i + 1)),
          };
        })
      : VIEWS.map(function (v) {
          return { img: "", label: c.name + " \u2014 " + v };
        });
  }
  function buildGallery() {
    if (track) {
      var slides = slidesForColour();
      ((track.innerHTML = slides
        .map(function (sl, i) {
          var inner = sl.img
            ? '<div class="ph"><img class="ph-img" src="' +
              sl.img +
              '" alt="' +
              sl.label +
              '" loading="' +
              (i === 0 ? "eager" : "lazy") +
              '"></div>'
            : '<div class="ph"><span class="ph-label">[ ' +
              sl.label +
              " ]</span></div>";
          return (
            '<div class="kc-slide' +
            (i === 0 ? " active" : "") +
            '" data-i="' +
            i +
            '">' +
            inner +
            "</div>"
          );
        })
        .join("")),
        (thumbsWrap.innerHTML = slides
          .map(function (sl, i) {
            var inner = sl.img
              ? '<div class="ph"><img class="ph-img" src="' +
                sl.img +
                '" alt="" loading="lazy"></div>'
              : '<div class="ph"><span class="ph-label">' +
                (VIEWS[i] || "View " + (i + 1)) +
                "</span></div>";
            return (
              '<button type="button" class="kc-thumb' +
              (i === 0 ? " active" : "") +
              '" data-i="' +
              i +
              '" aria-label="' +
              sl.label +
              '">' +
              inner +
              "</button>"
            );
          })
          .join("")),
        (dotsWrap.innerHTML = slides
          .map(function (sl, i) {
            return (
              '<button type="button" class="' +
              (i === 0 ? "active" : "") +
              '" data-i="' +
              i +
              '" aria-label="View ' +
              (i + 1) +
              '"></button>'
            );
          })
          .join("")),
        $$(".kc-thumb", thumbsWrap).forEach(function (b) {
          b.addEventListener("click", function () {
            goSlide(+b.dataset.i);
          });
        }),
        $$("button", dotsWrap).forEach(function (b) {
          b.addEventListener("click", function () {
            goSlide(+b.dataset.i);
          });
        }),
        (state.slide = 0),
        layoutSlides());
    }
  }
  function slideCount() {
    return $$(".kc-slide", track).length;
  }
  function layoutSlides() {
    if (track) {
      var desktop = window.matchMedia("(min-width: 981px)").matches;
      (desktop
        ? ((track.style.transform = ""),
          $$(".kc-slide", track).forEach(function (s, i) {
            (s.classList.toggle("active", i === state.slide),
              (s.style.position = "absolute"),
              (s.style.inset = "0"));
          }))
        : $$(".kc-slide", track).forEach(function (s) {
            ((s.style.position = ""), (s.style.inset = ""));
          }),
        updateCounter(),
        syncScrim());
    }
  }
  function goSlide(i) {
    var n = slideCount();
    if (n) {
      state.slide = (i + n) % n;
      var desktop = window.matchMedia("(min-width: 981px)").matches;
      ($$(".kc-slide", track).forEach(function (s, k) {
        s.classList.toggle("active", k === state.slide);
      }),
        desktop ||
          track.scrollTo({
            left: state.slide * track.clientWidth,
            behavior: "smooth",
          }),
        $$(".kc-thumb", thumbsWrap).forEach(function (b, k) {
          b.classList.toggle("active", k === state.slide);
        }),
        $$("button", dotsWrap).forEach(function (b, k) {
          b.classList.toggle("active", k === state.slide);
        }),
        updateCounter(),
        syncScrim());
    }
  }
  function updateCounter() {
    counter &&
      (counter.textContent = pad(state.slide + 1) + " / " + pad(slideCount()));
  }
  function pad(n) {
    return (n < 10 ? "0" : "") + n;
  }
  function syncScrim() {
    if (stage) {
      var slide = $$(".kc-slide", track)[state.slide],
        hasImg = !!(slide && slide.querySelector("img"));
      stage.classList.toggle("has-img", hasImg);
    }
  }
  if (track) {
    var kcScrollTimeout;
    if (
      (track.addEventListener(
        "scroll",
        function () {
          if (!window.matchMedia("(min-width: 981px)").matches) {
            var w =
                track.clientWidth ||
                (track.firstElementChild &&
                  track.firstElementChild.offsetWidth) ||
                1,
              idx = Math.round(track.scrollLeft / w);
            idx !== state.slide &&
              ((state.slide = idx),
              $$(".kc-slide", track).forEach(function (s, n) {
                s.classList.toggle("active", n === idx);
              }),
              $$(".kc-thumb", thumbsWrap).forEach(function (b, n) {
                b.classList.toggle("active", n === idx);
              }),
              $$("button", dotsWrap).forEach(function (b, n) {
                b.classList.toggle("active", n === idx);
              }),
              clearTimeout(kcScrollTimeout),
              (kcScrollTimeout = setTimeout(function () {
                thumbsWrap &&
                  thumbsWrap.children[idx] &&
                  thumbsWrap.children[idx].scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "center",
                  });
              }, 60)),
              updateCounter(),
              syncScrim());
          }
        },
        { passive: !0 },
      ),
      stage)
    ) {
      var kcTouchStartX = 0,
        kcTouchStartY = 0,
        kcTouchDiffX = 0,
        kcTouchDiffY = 0,
        kcIsSwiping = !1;
      (stage.addEventListener(
        "touchstart",
        function (e) {
          if (!window.matchMedia("(min-width: 981px)").matches) {
            var t = e.touches[0];
            t &&
              ((kcTouchStartX = t.clientX),
              (kcTouchStartY = t.clientY),
              (kcTouchDiffX = 0),
              (kcTouchDiffY = 0),
              (kcIsSwiping = !0));
          }
        },
        { passive: !0 },
      ),
        stage.addEventListener(
          "touchmove",
          function (e) {
            if (
              !(!kcIsSwiping || window.matchMedia("(min-width: 981px)").matches)
            ) {
              var t = e.touches[0];
              t &&
                ((kcTouchDiffX = t.clientX - kcTouchStartX),
                (kcTouchDiffY = t.clientY - kcTouchStartY));
            }
          },
          { passive: !0 },
        ),
        stage.addEventListener(
          "touchend",
          function () {
            if (
              !(
                !kcIsSwiping || window.matchMedia("(min-width: 981px)").matches
              ) &&
              ((kcIsSwiping = !1),
              Math.abs(kcTouchDiffX) > 35 &&
                Math.abs(kcTouchDiffX) > Math.abs(kcTouchDiffY))
            ) {
              var count = slideCount();
              kcTouchDiffX < 0
                ? goSlide(state.slide + 1)
                : goSlide(state.slide - 1);
            }
          },
          { passive: !0 },
        ));
    }
  }
  window.addEventListener("resize", layoutSlides);
  var page = $("#kcPage"),
    coloursWrap = $("#kcColours"),
    coloursMini = $("#kcColoursMini"),
    colourName = $("#kcColourName"),
    colourSub = $("#kcColourSub"),
    stickerA = $("#kcStickerA");
  function themeFor(id) {
    return /rain/.test(id) ? "rain" : /thunder/.test(id) ? "thunder" : "puddle";
  }
  function swatchHtml(c) {
    var inner = c.img
      ? '<img class="kc-col-img" src="' +
        c.img +
        '" alt="' +
        c.name +
        '" loading="lazy">'
      : '<span class="swatch" style="background:' +
        ((c.sw && c.sw[0]) || "#345") +
        '"></span><span class="ph"><span class="ph-label">' +
        c.name +
        "</span></span>";
    return (
      '<button type="button" class="kc-col' +
      (c.id === state.colour ? " active" : "") +
      '" data-c="' +
      c.id +
      '" aria-label="' +
      c.name +
      '">' +
      (c.flag ? '<span class="kc-col-flag">' + c.flag + "</span>" : "") +
      '<span class="kc-col-chip">' +
      inner +
      '</span><span class="kc-col-name">' +
      c.name +
      "</span></button>"
    );
  }
  function buildColourPicker() {
    if (coloursWrap) {
      var html = COLOURS.map(swatchHtml).join("");
      ((coloursWrap.innerHTML = html),
        coloursMini && (coloursMini.innerHTML = html),
        [coloursWrap, coloursMini].forEach(function (wrap) {
          wrap &&
            $$(".kc-col", wrap).forEach(function (b) {
              b.addEventListener("click", function () {
                selectColour(b.dataset.c, !0);
              });
            });
        }));
    }
  }
  function selectColour(id, scrollGallery) {
    if (colourObj(id)) {
      state.colour = id;
      var c = colourObj();
      (page && page.setAttribute("data-theme", themeFor(id)),
        colourName && (colourName.textContent = c.name),
        colourSub && (colourSub.textContent = c.sub || ""),
        stickerA && c.sticker && (stickerA.textContent = c.sticker),
        $$(".kc-col").forEach(function (b) {
          b.classList.toggle("active", b.dataset.c === id);
        }),
        $$(".kc-advcard").forEach(function (b) {
          b.classList.toggle("active", b.dataset.c === id);
        }),
        buildGallery(),
        stage &&
          (stage.classList.remove("bounce"),
          stage.offsetWidth,
          reduce || stage.classList.add("bounce")),
        renderSizes(),
        syncSticky(),
        syncAtc());
    }
  }
  $$(".kc-advcard").forEach(function (card) {
    card.addEventListener("click", function () {
      selectColour(card.dataset.c);
      var buy = $(".kc-buy");
      (buy &&
        window.scrollTo({
          top: buy.getBoundingClientRect().top + window.scrollY - 90,
          behavior: "smooth",
        }),
        toast(colourObj().name + " selected \u2713"));
    });
  });
  var sizesWrap = $("#kcSizes"),
    sizeMsg = $("#kcSizeMsg"),
    sizeMsgTxt = $("#kcSizeMsgTxt");
  function hashStr(str) {
    for (var h = 0, i = 0; i < str.length; i++)
      ((h = (h << 5) - h + str.charCodeAt(i)), (h |= 0));
    return Math.abs(h);
  }
  function seededShuffle(arr, seed) {
    var a = arr.slice(),
      s = seed || 1;
    function rnd() {
      return ((s = (s * 9301 + 49297) % 233280), s / 233280);
    }
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(rnd() * (i + 1)),
        tmp = a[i];
      ((a[i] = a[j]), (a[j] = tmp));
    }
    return a;
  }
  function effectiveLowSizes() {
    var inStock = SIZES.map(function (sz) {
        return sz.s;
      }).filter(function (s) {
        return !isSold(s);
      }),
      low = inStock.filter(function (s) {
        return isLow(s);
      });
    if (!low.length && inStock.length >= 2) {
      var seed = hashStr((DATA.title || "") + "|" + state.colour);
      low = seededShuffle(inStock, seed).slice(0, 1);
    }
    return low;
  }
  function renderSizes() {
    if (sizesWrap) {
      var low = effectiveLowSizes();
      ((sizesWrap.innerHTML = SIZES.map(function (sz) {
        var sold = isSold(sz.s),
          isLowSize = low.indexOf(sz.s) !== -1,
          cls =
            "kc-size" +
            (sz.s === state.size ? " active" : "") +
            (isLowSize && !sold ? " is-low" : ""),
          flag =
            isLowSize && !sold ? '<span class="kc-size-flag">Low</span>' : "";
        return (
          '<button type="button" class="' +
          cls +
          '" data-s="' +
          sz.s +
          '">' +
          flag +
          "<span>US " +
          sz.s +
          "</span>" +
          (sz.age ? '<span class="age">' + sz.age + "</span>" : "") +
          "</button>"
        );
      }).join("")),
        $$(".kc-size", sizesWrap).forEach(function (b) {
          b.addEventListener("click", function () {
            pickSize(b.dataset.s);
          });
        }),
        state.size &&
          !SIZES.some(function (x) {
            return x.s === state.size;
          }) &&
          (state.size = null),
        updateSizeFomo(low));
    }
  }
  function fmtSizeList(arr) {
    return arr.length <= 1
      ? arr.join("")
      : arr.length === 2
        ? arr[0] + " & " + arr[1]
        : arr.slice(0, -1).join(", ") + " & " + arr[arr.length - 1];
  }
  function updateSizeFomo(low) {
    var fomo = $("#kcSizeFomo");
    if (fomo) {
      var txt = fomo.querySelector(".kc-size-fomo-txt");
      if (!low || !low.length) {
        fomo.classList.add("is-quiet");
        return;
      }
      (fomo.classList.remove("is-quiet"),
        txt &&
          (txt.innerHTML =
            "<b>Low stock</b> \u2014 US " +
            fmtSizeList(low) +
            (low.length > 1 ? " are" : " is") +
            " almost gone."));
    }
  }
  function pickSize(s) {
    ((state.size = s),
      $$(".kc-size", sizesWrap).forEach(function (b) {
        b.classList.toggle("active", b.dataset.s === s);
      }),
      sizeMsg && sizeMsg.classList.add("hide"),
      syncSticky(),
      syncAtc());
  }
  var qtyEl = $("#kcQty"),
    qm = $("#kcQtyMinus");
  qm &&
    qm.addEventListener("click", function () {
      state.qty > 1 &&
        (state.qty--, (qtyEl.textContent = state.qty), syncAtc());
    });
  var qp = $("#kcQtyPlus");
  qp &&
    qp.addEventListener("click", function () {
      state.qty < 9 &&
        (state.qty++, (qtyEl.textContent = state.qty), syncAtc());
    });
  var atc = $("#kcAtc"),
    atcPrice = $("#kcAtcPrice");
  function syncVariantField() {
    var field = $("#kcVariantId");
    if (field) {
      var v = variantFor(state.colour, state.size);
      v && v.id && (field.value = v.id);
      var qField = $("#kcQtyField");
      qField && (qField.value = state.qty);
    }
  }
  function syncAtc() {
    if (atc) {
      syncVariantField();
      var selectedVariant = state.size
          ? variantFor(state.colour, state.size)
          : null,
        unitPriceCents =
          selectedVariant && selectedVariant.priceCents != null
            ? selectedVariant.priceCents
            : PRICE_CENTS,
        compareAtCents =
          selectedVariant && selectedVariant.compareAtCents != null
            ? selectedVariant.compareAtCents
            : DATA.compareAtCents || 0,
        kcPrice = $("#kcPrice"),
        kcPriceCompare = $("#kcPriceCompare"),
        kcPriceSave = $("#kcPriceSave");
      if (
        (kcPrice && (kcPrice.textContent = money(unitPriceCents)),
        kcPriceCompare && kcPriceSave)
      )
        if (compareAtCents > unitPriceCents) {
          ((kcPriceCompare.textContent = money(compareAtCents)),
            (kcPriceCompare.style.display = ""));
          var saveCents = compareAtCents - unitPriceCents;
          ((kcPriceSave.textContent = "Save " + money(saveCents)),
            (kcPriceSave.style.display = ""));
        } else
          ((kcPriceCompare.style.display = "none"),
            (kcPriceSave.style.display = "none"));
      var kcInstalAmount = $("#kcInstalAmount");
      if (kcInstalAmount) {
        var instalCents = Math.round(unitPriceCents / 4);
        kcInstalAmount.textContent = money(instalCents);
      }
      selectedSold()
        ? atc.classList.add("is-notify")
        : (atc.classList.remove("is-notify"),
          atcPrice &&
            (atcPrice.textContent = money(unitPriceCents * state.qty)));
    }
  }
  function requireSize() {
    if (!state.size) {
      sizeMsg &&
        (sizeMsg.classList.remove("hide"),
        (sizeMsgTxt.textContent =
          "Size required — select an available size above before adding to cart."));
      var grp = $("#kcSizeGroup");
      return (
        grp &&
          window.scrollTo({
            top: grp.getBoundingClientRect().top + window.scrollY - 120,
            behavior: "smooth",
          }),
        !1
      );
    }
    return !0;
  }
  function shopifyAdd(variantId, qty, onDone) {
    var url = DATA.cartAddUrl || "/cart/add.js";
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        document.dispatchEvent(
          new CustomEvent("oszea:cart:added", { detail: res }),
        );
        var bubble = $("#cartCount") || $("[data-cart-count]");
        if (bubble) {
          var n = (parseInt(bubble.textContent, 10) || 0) + qty;
          ((bubble.textContent = n), bubble.classList.add("show"));
        }
        onDone && onDone(res);
      })
      .catch(function () {
        toast("Could not add to cart \u2014 please try again.");
      });
  }
  function doAdd(buyNow) {
    if (!selectedSold() && requireSize()) {
      var c = colourObj(),
        v = variantFor(state.colour, state.size);
      if (!v || !v.id) {
        (toast(
          "Added " +
            (state.qty > 1 ? state.qty + "\xD7 " : "") +
            c.name +
            " \xB7 US " +
            state.size +
            " \u2713",
        ),
          buyNow && toast("Taking you to secure checkout\u2026"));
        return;
      }
      shopifyAdd(v.id, state.qty, function () {
        (toast(
          "Added " +
            (state.qty > 1 ? state.qty + "\xD7 " : "") +
            c.name +
            " \xB7 US " +
            state.size +
            " \u2713",
        ),
          buyNow && (window.location.href = "/checkout"));
      });
    }
  }
  atc &&
    atc.addEventListener("click", function () {
      selectedSold() || doAdd(!1);
    });
  var buyNowBtn = $("#kcBuyNow");
  buyNowBtn &&
    buyNowBtn.addEventListener("click", function () {
      doAdd(!0);
    });
  var sticky = $("#kcSticky"),
    stickyVar = $("#kcStickyVar"),
    stickySize = $("#kcStickySize"),
    stickyPrice = $("#kcStickyPrice"),
    stickyThumb = $("#kcStickyThumb"),
    stickyAtc = $("#kcStickyAtc");
  function buildStickySize() {
    stickySize &&
      ((stickySize.innerHTML =
        '<option value="">Size</option>' +
        SIZES.map(function (sz) {
          return (
            '<option value="' +
            sz.s +
            '"' +
            (isSold(sz.s) ? " disabled" : "") +
            ">US " +
            sz.s +
            (isSold(sz.s) ? " \u2014 sold out" : "") +
            "</option>"
          );
        }).join("")),
      (stickySize.value = state.size || ""));
  }
  (stickySize &&
    stickySize.addEventListener("change", function () {
      this.value && pickSize(this.value);
    }),
    stickyAtc &&
      stickyAtc.addEventListener("click", function () {
        selectedSold() || doAdd(!1);
      }));
  function syncSticky() {
    if (sticky) {
      var c = colourObj();
      (buildStickySize(),
        stickyVar &&
          (stickyVar.textContent =
            c.name +
            (state.size ? " \xB7 US " + state.size : " \xB7 Pick size")),
        stickyThumb &&
          (stickyThumb.style.background = c.accent || "var(--ka-soft)"),
        stickyPrice && (stickyPrice.textContent = money(PRICE_CENTS)),
        atc && (atc.disabled = selectedSold()),
        stickyAtc &&
          ((stickyAtc.textContent = selectedSold()
            ? "Out of Stock"
            : "Add to Cart"),
          (stickyAtc.disabled = selectedSold())));
    }
  }
  (function () {
    var buyBtn = $(".kc-buyrow");
    if (!(!buyBtn || !sticky) && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (ents) {
          ents.forEach(function (e) {
            var scrolledPast =
              !e.isIntersecting && e.boundingClientRect.top < 0;
            sticky.classList.toggle(
              "show",
              scrolledPast && window.matchMedia("(max-width: 980px)").matches,
            );
          });
        },
        { rootMargin: "0px 0px -40% 0px" },
      );
      io.observe(buyBtn);
    }
  })();
  var szModal = $("#kcSizeModal");
  function openSize() {
    szModal &&
      (szModal.classList.add("open"),
      szModal.setAttribute("aria-hidden", "false"),
      (document.body.style.overflow = "hidden"));
  }
  function closeSize() {
    szModal &&
      (szModal.classList.remove("open"),
      szModal.setAttribute("aria-hidden", "true"),
      (document.body.style.overflow = ""));
  }
  (["#kcSizeGuide", "#kcOpenSize2", "#navSizeGuide", "#mSizeGuide"].forEach(
    function (sel) {
      var el = $(sel);
      el &&
        el.addEventListener("click", function (e) {
          (e.preventDefault(), openSize());
        });
    },
  ),
    $$("[data-size-close]").forEach(function (b) {
      b.addEventListener("click", closeSize);
    }));
  var nmModal = $("#kcNotifyModal"),
    nmSw = $("#kcNmSw"),
    nmLine = $("#kcNmLine"),
    nmField = $("#kcNmVariantField");
  function openNotify() {
    if (nmModal) {
      var c = colourObj();
      nmSw && (nmSw.style.background = c.accent || "var(--ka)");
      var line = c.name + (state.size ? " \xB7 US " + state.size : "");
      (nmLine && (nmLine.textContent = line),
        nmField && (nmField.value = line),
        nmModal.classList.add("open"),
        nmModal.setAttribute("aria-hidden", "false"),
        (document.body.style.overflow = "hidden"));
    }
  }
  function closeNotify() {
    nmModal &&
      (nmModal.classList.remove("open"),
      nmModal.setAttribute("aria-hidden", "true"),
      (document.body.style.overflow = ""));
  }
  $$("[data-notify-close]").forEach(function (b) {
    b.addEventListener("click", closeNotify);
  });
  var nmForm = $("#kcNotifyForm");
  (nmForm &&
    nmForm.dataset.live !== "true" &&
    nmForm.addEventListener("submit", function (e) {
      e.preventDefault();
      var email = nmForm.querySelector("input[type=email]"),
        v = email.value.trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) {
        ((email.style.borderColor = "var(--orange)"), email.focus());
        return;
      }
      (closeNotify(),
        toast(
          "You're on the list \u2014 we'll email you when it's back \u2614",
        ));
    }),
    document.addEventListener("keydown", function (e) {
      e.key === "Escape" &&
        (szModal && szModal.classList.contains("open") && closeSize(),
        nmModal && nmModal.classList.contains("open") && closeNotify());
    }),
    (function () {
      var canvas = $("#kcColorCanvas");
      if (canvas) {
        var svg = $("svg", canvas);
        if (svg) {
          var active = "#EE7FA6",
            hint = $("#kcColorHint"),
            painted = 0;
          ($$(".kc-swatch", $("#kcSwatches")).forEach(function (b) {
            b.addEventListener("click", function () {
              ((active = b.dataset.color),
                $$(".kc-swatch").forEach(function (x) {
                  x.classList.remove("active");
                }),
                b.classList.add("active"));
            });
          }),
            $$("[data-fill]", svg).forEach(function (shape) {
              shape.addEventListener("click", function () {
                (shape.tagName.toLowerCase() === "g"
                  ? shape.querySelectorAll("*").forEach(function (t) {
                      t.hasAttribute("fill") && t.setAttribute("fill", active);
                    })
                  : shape.setAttribute("fill", active),
                  hint && painted === 0 && (hint.style.opacity = "0"),
                  painted++);
              });
            }));
          var reset = $("#kcColorReset");
          reset &&
            reset.addEventListener("click", function () {
              ($$("[data-fill]", svg).forEach(function (shape) {
                shape.tagName.toLowerCase() === "g"
                  ? shape.querySelectorAll("*").forEach(function (t) {
                      t.hasAttribute("fill") &&
                        t.setAttribute("fill", "#ffffff");
                    })
                  : shape.setAttribute("fill", "#ffffff");
              }),
                (painted = 0),
                hint && (hint.style.opacity = ""));
            });
          var dl = $("#kcDownloadSheet");
          dl &&
            dl.addEventListener("click", function (e) {
              if (
                dl.tagName.toLowerCase() === "a" &&
                dl.getAttribute("href") &&
                dl.getAttribute("href") !== "#"
              ) {
                toast("Colouring sheet downloading \uD83C\uDFA8");
                return;
              }
              e && e.preventDefault && e.preventDefault();
              var clone = svg.cloneNode(!0);
              ($$("[data-fill]", clone).forEach(function (s) {
                s.tagName.toLowerCase() === "g"
                  ? s.querySelectorAll("*").forEach(function (t) {
                      t.hasAttribute("fill") &&
                        t.setAttribute("fill", "#ffffff");
                    })
                  : s.hasAttribute("fill") && s.setAttribute("fill", "#ffffff");
              }),
                clone.setAttribute("xmlns", "http://www.w3.org/2000/svg"));
              var svgStr =
                  '<?xml version="1.0" encoding="UTF-8"?>\n' + clone.outerHTML,
                svgBlob = new Blob([svgStr], {
                  type: "image/svg+xml;charset=utf-8",
                }),
                svgUrl = URL.createObjectURL(svgBlob),
                scale = 3,
                img = new Image();
              ((img.onload = function () {
                var out = document.createElement("canvas");
                ((out.width = 400 * scale), (out.height = 300 * scale));
                var ctx = out.getContext("2d");
                ((ctx.fillStyle = "#ffffff"),
                  ctx.fillRect(0, 0, out.width, out.height),
                  ctx.drawImage(img, 0, 0, out.width, out.height),
                  URL.revokeObjectURL(svgUrl),
                  out.toBlob(
                    function (jpgBlob) {
                      if (!jpgBlob) {
                        toast(
                          "Could not prepare download \u2014 please try again.",
                        );
                        return;
                      }
                      var jpgUrl = URL.createObjectURL(jpgBlob),
                        a = document.createElement("a");
                      ((a.href = jpgUrl),
                        (a.download = "OSZEA-Kids-Colouring-Sheet.jpg"),
                        document.body.appendChild(a),
                        a.click(),
                        a.remove(),
                        URL.revokeObjectURL(jpgUrl),
                        toast("Colouring sheet downloaded \uD83C\uDFA8"));
                    },
                    "image/jpeg",
                    0.92,
                  ));
              }),
                (img.onerror = function () {
                  (URL.revokeObjectURL(svgUrl),
                    toast(
                      "Could not prepare download \u2014 please try again.",
                    ));
                }),
                (img.src = svgUrl));
            });
          var share = $("#kcShareRain");
          share &&
            share.addEventListener("click", function () {
              var txt =
                "Colouring our OSZEA box for puddle season \u2614 #RainClub";
              navigator.share
                ? navigator
                    .share({ title: "OSZEA #RainClub", text: txt })
                    .catch(function () {})
                : navigator.clipboard
                  ? (navigator.clipboard.writeText("#RainClub"),
                    toast("#RainClub copied \u2014 share your creation!"))
                  : toast("Tag us with #RainClub!");
            });
        }
      }
    })(),
    $$("#kcFaq .kc-faq-item").forEach(function (item) {
      var q = $(".kc-faq-q", item),
        a = $(".kc-faq-a", item);
      function set(open) {
        (item.classList.toggle("open", open),
          (a.style.maxHeight = open ? a.scrollHeight + "px" : "0px"));
      }
      (item.classList.contains("open") &&
        requestAnimationFrame(function () {
          set(!0);
        }),
        q.addEventListener("click", function () {
          set(!item.classList.contains("open"));
        }));
    }),
    window.addEventListener("resize", function () {
      $$("#kcFaq .kc-faq-item.open .kc-faq-a").forEach(function (a) {
        a.style.maxHeight = a.scrollHeight + "px";
      });
    }),
    $$(".kc-kitadd").forEach(function (b) {
      b.addEventListener("click", function () {
        var name = b.dataset.add || "Item",
          vid = b.getAttribute("data-variant-id"),
          label = b.getAttribute("data-default-label") || "",
          done = function () {
            b.classList.add("added");
            var old = b.textContent;
            ((b.textContent = "Added \u2713"),
              toast(name + " added to your kit \u2713"),
              setTimeout(function () {
                (b.classList.remove("added"), (b.textContent = old));
              }, 1900));
          };
        vid ? shopifyAdd(parseInt(vid, 10), 1, done) : done();
      });
    }),
    $$("[data-shop]").forEach(function (b) {
      b.addEventListener("click", function () {
        selectedSold() || (requireSize() && doAdd(!1));
      });
    }));
  var finalChoose = $("#kcFinalChoose");
  (finalChoose &&
    finalChoose.addEventListener("click", function () {
      var adv = $("#kcAdv");
      adv &&
        window.scrollTo({
          top: adv.getBoundingClientRect().top + window.scrollY - 80,
          behavior: "smooth",
        });
    }),
    $$(".jdg-rev-carousel").forEach(function (car) {
      var track2 = $(".jdg-rev-track", car),
        prev = $(".jdg-rev-prev", car),
        next = $(".jdg-rev-next", car),
        card = $(".jdg-rev-card", track2);
      if (!track2 || !card) return;
      function step() {
        return card.getBoundingClientRect().width + 16;
      }
      function update() {
        var max = track2.scrollWidth - track2.clientWidth - 2;
        (prev && (prev.disabled = track2.scrollLeft <= 2),
          next && (next.disabled = track2.scrollLeft >= max));
      }
      (prev &&
        prev.addEventListener("click", function () {
          track2.scrollBy({
            left: -step(),
            behavior: reduce ? "auto" : "smooth",
          });
        }),
        next &&
          next.addEventListener("click", function () {
            track2.scrollBy({
              left: step(),
              behavior: reduce ? "auto" : "smooth",
            });
          }),
        track2.addEventListener("scroll", update, { passive: !0 }),
        update());
    }),
    (function () {
      var els = $$(".reveal");
      if (els.length) {
        var showAll = function () {
          els.forEach(function (e) {
            e.classList.add("in");
          });
        };
        if (reduce || !("IntersectionObserver" in window)) {
          showAll();
          return;
        }
        var io = new IntersectionObserver(
          function (ents) {
            ents.forEach(function (en) {
              en.isIntersecting &&
                (en.target.classList.add("in"), io.unobserve(en.target));
            });
          },
          { rootMargin: "0px 0px -6% 0px", threshold: 0.04 },
        );
        (els.forEach(function (e) {
          io.observe(e);
        }),
          setTimeout(showAll, 1600));
      }
    })(),
    buildColourPicker(),
    renderSizes(),
    selectColour(state.colour),
    syncSticky(),
    syncAtc());
})();
//# sourceMappingURL=/cdn/shop/t/36/assets/oszea-kids.js.map
